import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {startOfDay, addYears} from 'date-fns'
import {dateToUTC} from '../../../utils'

import {search} from '../../../actions'

import Button from '@mui/material/Button'

import {ReactComponent as Desert} from '../../../svgs/Desert.svg'



const cssStyles = ({isExtraSmallScreen}) => ({
  root: css`
    position: absolute;
    top: 0;
    width: 70%;
    max-width: 400px;
    height: calc(100% - 61px); 
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  noticeContainer: css`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 287px;
  `,
  messageContainer: css`   
    width: 100%;
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 20;

    h4 {
      font-size: ${isExtraSmallScreen ? '1.1rem' : '1.2rem'};
      margin-bottom: 5px;
      color: #7b7b7b;
      font-weight: 600;
      text-align: center;
    }

    p {
      font-size: 0.9rem;
      color: #7b7b7b;
      max-width: 250px;
      line-height: 1.2;
      text-align: center;
    }

    @media (max-width: 600px) {
      position: absolute; 
    }
  `,
  button: css`
    height: 42px;
    padding-left: 35px;
    padding-right: 35px; 
    font-size: 0.8rem;
    border-radius: calc(42px / 2);
    box-shadow: none;
    margin-top: 15px;
  `,
  imageContainer: css`
    position: relative;
    height: 100%;
    width: 100%;
  `,
  overlay: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; 
    background-color: #fff;
    opacity: 0.9;
  `
})



const MapListNotice = props => {

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))

  const styles = cssStyles({isExtraSmallScreen})


  const {
    lat,
    lng,
    search,
    itemCount,
    isFetching,
    performanceSearchCount
  } = props



  function searchClosest() {
    const data = {}
    const date = new Date()

    data['location'] = {lat, lng}

    const start = startOfDay(date)
    const end = addYears(startOfDay(date), 1)

    const utcDate = {start: dateToUTC(start), end: dateToUTC(end)}

    data['time'] = utcDate

    search('search/performances/near', data, 'PERFORMANCE')
  }




  return (
    <div css={styles.root}>
      {/*performanceSearchCount > 0 && itemCount === 0 && !isFetching &&*/ true &&
        <div css={styles.noticeContainer}>
          <div css={styles.imageContainer}>
            <Desert />

            <div css={styles.overlay}></div>
          </div>


          <div css={styles.messageContainer}>
            <h4>Uh Oh, No Results</h4>

            <p>
              {performanceSearchCount === 1
                ? 'We couldn\'t find any performances near your location. To expand the search distance, click the button below.'
                : 'We couldn\'t find any performances with the selected search criteria.'
              }
            </p>

            {performanceSearchCount === 1 &&
              <Button css={styles.button} variant='contained' onClick={searchClosest}>
                Expand Search
              </Button>
            }
          </div>
        </div>
      }
    </div>
  )
}




const mapStateToProps = state => {
  const {lat, lng} = state.user.location
  const {performance, counter} = state.search 


  return {
    lat,
    lng,
    itemCount: performance.results.length,
    isFetching: performance.isFetching,
    performanceSearchCount: counter.performance
  }
}



export default connect(mapStateToProps, {search})(MapListNotice)


